var React = require('react');

function Volume (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 88v336c0 21.44-25.94 32-41 17l-89-88.95H24A24 24 0 0 1 0 328V184a24 24 0 0 1 24-24h102.06l89-88.95C230 56 256 66.56 256 88z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M338.23 179.13a24 24 0 1 0-23.16 42.06 39.42 39.42 0 0 1 0 69.62 24 24 0 1 0 23.16 42.06 87.43 87.43 0 0 0 0-153.74zm56-79.37a23.9 23.9 0 0 0-33.12 7.46 24.29 24.29 0 0 0 7.41 33.36 136.67 136.67 0 0 1 0 230.84 24.28 24.28 0 0 0-7.41 33.36 23.94 23.94 0 0 0 33.12 7.46 185.19 185.19 0 0 0 0-312.48z","className":"fa-primary","key":2})]);
}

Volume.defaultProps = {"viewBox":"0 0 480 512","className":"icon"};

module.exports = Volume;

Volume.default = Volume;
